import { render, staticRenderFns } from "./who-is-family.vue?vue&type=template&id=6a559ce0&scoped=true&"
import script from "./who-is-family.vue?vue&type=script&lang=js&"
export * from "./who-is-family.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a559ce0",
  null
  
)

export default component.exports